import type { ReactNode } from "react";

/** Plain reading layout for the privacy policy and terms. */
export default function LegalLayout({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 sm:py-20">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-brand-700">Legal</p>
      <h1 className="text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">{title}</h1>
      <p className="mt-3 text-sm text-ink-500">{updated}</p>
      <div className="legal mt-10 space-y-8 text-[15px] leading-relaxed text-ink-700 [&_a]:font-semibold [&_a]:text-brand-700 [&_a:hover]:text-brand-600 [&_h2]:mb-3 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-ink-900 [&_li]:mt-1.5 [&_p+p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-5">
        {children}
      </div>
    </div>
  );
}
